/**
 * @typedef {Object} DashboardOverviewActivitiesStats
 * @property {number} totalActivities
 * @property {number} totalRedeems
 * @property {number} totalFollows
 * @property {number} totalRaids
 * @property {number} totalBits
 * @property {number} totalSubs
 */

/**
 * @typedef {Object} DashboardOverviewBadwordStats
 * @property {number} totalBadwords
 */

/**
 * @typedef {Object} DashboardOverviewCommandStats
 * @property {number} totalCommands
 */

/**
 * @typedef {Object} DashboardOverviewActivityDatapoint
 * @property {string} date
 * @property {number} count
 */

/**
 * @typedef {Object} DashboardOverviewRedeemRankingItem
 * @property {string} title
 * @property {number} count
 */

/**
 * @typedef {Object} DashboardOverviewEmojiRankingItem
 * @property {string} name
 * @property {number} count
 */

/**
 * @typedef {Object} DashboardOverviewViewerRankingItem
 * @property {string} name
 * @property {number} count
 */

/**
 * @typedef {Object} DashboardOverview
 * @property {?DashboardOverviewActivitiesStats} activitiesStats
 * @property {?DashboardOverviewBadwordStats} badwordStats
 * @property {?DashboardOverviewCommandStats} commandStats
 * @property {?Array<DashboardOverviewActivityDatapoint>} activityGraph
 * @property {?Array<DashboardOverviewRedeemRankingItem>} topRedeems
 * @property {?Array<DashboardOverviewEmojiRankingItem>} topEmoji
 * @property {?Array<DashboardOverviewViewerRankingItem>} topViewersByActivity
 */

/**
 * @typedef {Object} DashboardService
 * @property {function(): angular.IPromise<DashboardOverview>} get
 */

const mod = require('../bahabot.module.js')

/**
 * @param {angular.resource.IResourceService} $resource
 * @param {angular.IQService} $q
 * @returns {DashboardService}
 */
function bahabotDashboardFactory($resource, $q) {
    const DashboardOverview = $resource('/api/protected/dashboard/overview', {}, {
        get:    { method: 'GET' },
    });

    return {
        get: function(offset) {
            return DashboardOverview.get({ offset }).$promise.then(res => res.data);
        },
    };
}

mod.factory('DashboardService', ["$resource", bahabotDashboardFactory]);
